import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { PrimaryButton } from './Button'
import boat from '../images/boat.svg'

class Pricing extends Component {

  componentDidMount = () => {
    window.analytics.page()
  }

  render(){

    return (
      <div className="pa3 mw8 center">
        <div className="br2 shadow-custom bg-white cf pa3 pa5-ns flex-ns items-center-ns">
          <div className="w-100 w-50-ns fl pa4">
            <img src={boat} alt='Pricing' className="h5"/>
          </div>
          <div className="w-100 w-50-ns fl">

            <div className="ba br2 b--black-10 pa4">
            <h3 className="f4 fw6 ma0">Try Polaris free for 14 days</h3>
              <h4 className="fw3 f2 f2-ns ma0">only $7.99 per month after trial</h4>
              <p className="gray ma0 mb4">Cancel anytime</p>
              <ol className="pl3 gray bt b--black-10 pt4 mt4 v">
                <li className="mb2">&#10004; Practical Stock Valuations</li>
                <li className="mb2">&#10004; Actionable Investments Plans</li>
                <li className="mb2">&#10004; Portfolio App with comparison to SP500</li>
                <li className="mb2">&#10004; Fully Responsive Support</li>
              </ol>

              <Link to="/register" className="">
                <PrimaryButton className="w-100">Sign up</PrimaryButton>
              </Link>

              <p className="mb0">Become a more confident investor today.</p>
            </div>








          </div>
        </div>
      </div>

    )
  }
}

export default Pricing



// WEBPACK FOOTER //
// ./src/components/Pricing.js